import { cubicEaseOut, inViewFade } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import { imageCoverContainer } from '@helpers/image';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  position: relative;
  z-index: 10;
`;
const ItemList = styled.div `
  display: flex;
  flex-wrap: wrap;

  ${inViewFade({ delay: 0, duration: 0.3 })};
`;
const Item = styled.a `
  position: relative;
  display: grid;
  flex: 0 0 50%;
  text-decoration: none;

  @media ${from(Device.TabletLarge)} {
    flex: 0 0 25%;
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  grid-area: 1 / 1;
  z-index: 1;
  overflow: hidden;
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer(true)}
  transition: transform 0.15s ${cubicEaseOut};
  will-change: transform;

  ${Item}:focus &,
  ${Item}:hover & {
    transform: scale(1.1);
  }
`;
const Title = styled.h3 `
  ${paragraphSmall};

  position: relative;
  display: block;
  align-self: flex-end;
  color: ${brand.white};
  background: ${rgba(brand.black, 0.74)};
  grid-area: 1 / 1;
  justify-self: flex-start;
  line-height: 1em;
  margin: 8px;
  padding: 8px 6px 0px;
  z-index: 2;

  @media ${from(Device.TabletLarge)} {
    padding: 10px 10px 2px;
  }
`;
const BlockCategoryGridStyles = {
    Container,
    Image,
    ImageWrapper,
    Item,
    ItemList,
    Title,
};
export default BlockCategoryGridStyles;
